module.exports = function() {
  return new Worker(__webpack_public_path__ + "2bfa051ee8cded280541.worker.js");
};